import type { TimestampMillis } from './common';

export const STATUS_STATES = ['operational', 'degraded', 'down'] as const;

export type StatusState = (typeof STATUS_STATES)[number];

export const STATUS_OVERALL_STATES = [...STATUS_STATES, 'unknown'] as const;

export type StatusOverallState = (typeof STATUS_OVERALL_STATES)[number];

export const STATUS_PROBES = [
  'api',
  'dashboard',
  'database',
  'cache',
  'storage',
  'obfuscation',
  'auth',
] as const;

export type StatusProbe = (typeof STATUS_PROBES)[number];

export const STATUS_INCIDENT_STATES = ['investigating', 'identified', 'monitoring', 'resolved'] as const;

export type StatusIncidentState = (typeof STATUS_INCIDENT_STATES)[number];

export const STATUS_SEVERITIES = ['minor', 'major', 'critical'] as const;

export type StatusSeverity = (typeof STATUS_SEVERITIES)[number];

export const STATUS_UPTIME_WINDOW_DAYS = 90;

export const STATUS_INCIDENT_LOOKBACK_DAYS = 14;

export interface StatusUptimeDay {
  day: string;
  checks: number;
  failures: number;
  uptime_percent: number;
}

export interface StatusComponent {
  id: string;
  name: string;
  description: string;
  probe: StatusProbe;
  state: StatusState;
  uptime_percent: number;
  latency_ms: number | null;
  last_checked_at: TimestampMillis | null;
  days: StatusUptimeDay[];
}

export interface StatusIncident {
  id: string;
  component_id: string;
  component_name: string;
  title: string;
  state: StatusIncidentState;
  severity: StatusSeverity;
  started_at: TimestampMillis;
  updated_at: TimestampMillis;
  resolved_at: TimestampMillis | null;
}

export interface StatusResponse {
  service: string;
  version: string;
  environment: string;
  generated_at: TimestampMillis;
  window_days: number;
  overall: StatusOverallState;
  last_probe_at: TimestampMillis | null;
  components: StatusComponent[];
  incidents: StatusIncident[];
}

export const STATUS_STATE_LABELS: Record<StatusState, string> = {
  operational: 'Operational',
  degraded: 'Degraded performance',
  down: 'Major outage',
};
